var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcStreaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 50,
    height: 30,
    rx: 2.41593,
    stroke: "#B6B6B6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9611 26.2635C39.3048 27.0313 39.3048 28.9687 37.9611 29.7365L29.9923 34.2901C28.659 35.052 27 34.0893 27 32.5536L27 23.4464C27 21.9107 28.659 20.948 29.9923 21.7099L37.9611 26.2635Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcStreaming);
export default __webpack_public_path__ + "static/media/stick-ic-streaming.3d8f24d0089db84145aa980676177620.svg";
export { ForwardRef as ReactComponent };